"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVCPopulatedUser = void 0;
var uuid_1 = require("uuid");
var package_json_1 = __importDefault(require("../package.json"));
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var DVCPopulatedUser = /** @class */ (function () {
    function DVCPopulatedUser(user, options, staticData, anonymousUserId) {
        var _a;
        if (((_a = user.user_id) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
            throw new Error('A User cannot be created with a user_id that is an empty string');
        }
        this.user_id =
            user.isAnonymous || !user.user_id
                ? user.user_id || anonymousUserId || (0, uuid_1.v4)()
                : user.user_id;
        this.isAnonymous = user.isAnonymous || !user.user_id;
        this.email = user.email;
        this.name = user.name;
        this.language = user.language;
        this.country = user.country;
        this.appVersion = user.appVersion;
        this.appBuild = user.appBuild;
        this.customData = user.customData;
        this.privateCustomData = user.privateCustomData;
        this.lastSeenDate = new Date();
        /**
         * Read only properties initialized once
         */
        if (staticData) {
            Object.assign(this, staticData);
        }
        else {
            var userAgent = new ua_parser_js_1.default(typeof window !== 'undefined'
                ? window.navigator.userAgent
                : undefined);
            var platformVersion = userAgent.getBrowser().name &&
                "".concat(userAgent.getBrowser().name, " ").concat(userAgent.getBrowser().version);
            this.createdDate = new Date();
            this.platform = (options === null || options === void 0 ? void 0 : options.reactNative) ? 'ReactNative' : 'web';
            this.platformVersion = platformVersion !== null && platformVersion !== void 0 ? platformVersion : 'unknown';
            this.deviceModel =
                (options === null || options === void 0 ? void 0 : options.reactNative) && globalThis.DeviceInfo
                    ? globalThis.DeviceInfo.getModel()
                    : typeof window !== 'undefined'
                        ? window.navigator.userAgent
                        : 'SSR - unknown';
            this.sdkType = 'client';
            this.sdkVersion = package_json_1.default.version;
        }
    }
    DVCPopulatedUser.prototype.getStaticData = function () {
        return {
            createdDate: this.createdDate,
            platform: this.platform,
            platformVersion: this.platformVersion,
            deviceModel: this.deviceModel,
            sdkType: this.sdkType,
            sdkVersion: this.sdkVersion,
        };
    };
    DVCPopulatedUser.prototype.updateUser = function (user, options) {
        if (this.user_id !== user.user_id) {
            throw new Error('Cannot update a user with a different user_id');
        }
        return new DVCPopulatedUser(user, options, this.getStaticData());
    };
    return DVCPopulatedUser;
}());
exports.DVCPopulatedUser = DVCPopulatedUser;
//# sourceMappingURL=User.js.map